const PROJECT_API = "https://api.p.sg2.kenobi.win/projects";

export default PROJECT_API;
